module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAABSUlEQVQYGXXBTWgNAAAH8D/lzaIVK60cVvJRNoenZWvJx12UdvDRDi4+DisuSkrK5ICiSO+EJuUg5WCH5UyOVpLbRrPXGuWlXrbnZ+9tjWG/X+pcNeWJ5izPbd+cNOlRGhQcVrQqv7mkYmeiV81A5ugy7adJ563IPFP60mDArGIabHTOtBGF1HnnaBaYcCHR4ZWHtthkzN3UueFFGtxTsTmxzoCXKrrtw9Yk2tX0JC76YU8WKRlNvHU5de4YtVK/WfuzyA5sV/I0ddYacz3x3IS2LLBaSYtD+jPPLjUHrTfujTVZjlO+69Kh7LXWzNHiiPYsZdBXnbYZM65bmw8+qzqdpdz0RY8Nhs2YNJQ4Y0ZJU/7kmqoTiWOupEGvsmdZylk1tzRnkeOq+ZvdPnpvbxp0Knucf2n1AMP6HFA2opD/U3TfJxVDmpJfJrf/A8vSoywAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/bottom_phone.png
// module id = g2UH
// module chunks = 32